<template>
  <div>
    <div class="box-pie" style="height: 500px" ref="chart"></div>
  </div>
</template>
<script>
export default {
  name: "ecbargraph",
  data() {
    return {
      option: {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      },
      // 配置可视化图形
    };
  },
  mounted() {
    this.getchart();
  },
  methods: {
    getchart() {
      // 引用chart并初始化
      this.chart = this.$echarts.init(this.$refs.chart);
      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(this.option);
      //自适应
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/view/page/Statistics/EcBarGraph.vue